import { Component, inject } from '@angular/core';
import {
  IonApp,
  IonContent,
  IonItem,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonSpinner
} from '@ionic/angular/standalone';
import { AuthService } from '@app/core/auth/auth.service';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, first, map, startWith, switchMap, timer } from 'rxjs';
import { RouterLink } from '@angular/router';
import { version } from '../../package.json';
import { ANIMATION_DURATION } from "@app/app.constants";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrl: 'app.component.css',
  imports: [IonApp, IonRouterOutlet, IonSpinner, IonContent, IonItem, IonList, IonMenu, RouterLink, IonMenuToggle]
})
export class AppComponent {
  readonly #auth = inject(AuthService);

  isLoading = toSignal(
    combineLatest([
      toObservable(this.#auth.isLoggedIn),
      timer(ANIMATION_DURATION),
    ]).pipe(
      first(),
      switchMap(() => {
        document.getElementById('full-page-loader')!.classList.add('opacity-0');

        return timer(400);
      }),
      map(() => false),
      startWith(true),
    )
  );

  readonly copyright = ((year) => {
    if (year === 2025) {
      return '2025';
    }

    return `2025-${year}`;
  })(new Date().getFullYear());

  readonly version = version;
}
